<template>
  <div>
    <main class="kontakt">
      <Breadcrumb :items="breadcrumb" />
      <div class="grid grid--center">
        <div class="grid__item grid__item--12">
          <Heading
            size="xl"
            class="text--center text--spacing-kontakt"
            spaces-bottom
          >
            Kontakt
          </Heading>
        </div>
      </div>

      <div class="grid grid--center">
        <TabGroup
          :tabs="tabsData"
          class="grid__item grid__item--12 grid__item--spacing-3"
        >
          <template #hotline>
            <TabGroupEntry>
              <div class="grid grid--center">
                <div class="grid__item grid__item--12 grid__item--m-6 grid__item--l-4">
                  <TextImage :text-image-data="textImageData.hotline[0]" />
                </div>
                <div
                  class="grid__item grid__item--12 grid__item--m-6 grid__item--l-4 grid__item--l-offset-2"
                >
                  <TextImage :text-image-data="textImageData.hotline[1]" />
                </div>
              </div>
            </TabGroupEntry>
          </template>
          <template #e-mail>
            <TabGroupEntry>
              <div class="grid grid--center">
                <div class="grid__item grid__item--12 grid__item--m-6 grid__item--l-4">
                  <TextImage :text-image-data="textImageData.email[0]" />
                </div>
                <div
                  class="grid__item grid__item--12 grid__item--m-6 grid__item--l-4 grid__item--l-offset-2"
                >
                  <TextImage :text-image-data="textImageData.email[1]" />
                </div>
              </div>
            </TabGroupEntry>
          </template>
          <template #shops>
            <TabGroupEntry>
              <div class="grid grid--center">
                <div class="grid__item grid__item--12 text--center">
                  <TextImage :text-image-data="textImageData.shops" />
                </div>
                <div class="grid__item grid__item--12 grid__item--m-8 grid__item--l-5">
                  <ShopFinder :spaces="false" />
                </div>
              </div>
            </TabGroupEntry>
          </template>
        </TabGroup>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from '#imports';
import Breadcrumb from '@/components/breadcrumb.vue';
import ShopFinder from '@/components/shop-finder.vue';
import TabGroup from '@/components/tab-group.vue';
import TabGroupEntry from '@/components/tab-group-entry.vue';
import TextImage from '@/components/text-image.vue';
import { Heading } from '@i22-td-smarthome/component-library';
import { Track } from '~/helpers/page-tracking';
import { getHeader } from '~/helpers/page-header-compositon';
import externalLinkIcon from '@/assets/images/external-link-string.json';

Track({ page_type: 'theme.contact' });

getHeader({
  title: ref('Kontakt'),
  isIndexed: ref(false),
  description: ref(
    'Du kannst uns online, telefonisch oder persönlich erreichen per E-Mail, Chat, Community, Hotline, oder in einem Telekom Shop in Deiner Nähe.'
  ),
});

const $route = useRoute();

const textImageData = ref({
  hotline: [
    {
      theme: 'dark',
      align: 'left',
      content:
        '<h2 class="text--h4 text--mb">Kontakt zur Telekom</h2><div><h3 class="text--h5 text--mb">Hotlines</h3><p class="text">Kostenlos, rund um die Uhr, 7 Tage die Woche.</p></div><ul class="list grid__item--spacing-1"><li class="list__element">Bestellung: <span class="text text--highlighted">0800 33 03000</span></li><li class="list__element">Kundenservice Festnetz: <span class="text text--highlighted">0800 33 01000</span></li><li class="list__element">Kundenservice Mobilfunk: <span class="text text--highlighted">0800 33 02202</span></li><li class="list__element">vom Handy: <span class="text text--highlighted">2202</span></li></ul><p class="text"><span class="text">Kundenservice MagentaEins Plus: </span><span class="text text--highlighted">0800 33 01000</span></p>',
    },
    {
      theme: 'dark',
      align: 'left',
      content:
        '<h2 class="text--h4 text--mb">Kontakt zur Brodos</h2><div>Wir helfen bei:</div><ul class="list grid__item--spacing-1"><li class="list__element list__element--dashed">Fragen rund um Geräte-Lieferungen der Brodos AG</li></ul><p><a class="link" href="tel:091336084350">09133 6084 350</a><br />Servicezeiten: Montag - Freitag 08:00–17:00 Uhr</p>',
    },
  ],
  email: [
    {
      theme: 'dark',
      align: 'left',
      content: `<h2 class="text--h4 text--mb">Kontakt zur Telekom</h2><div>Wir helfen bei Fragen zum Thema:</div><ul class="list grid__item--spacing-1"><li class="list__element list__element--dashed">Mobilfunk</li><li class="list__element list__element--dashed">Festnetz</li></ul><a href="https://www.telekom.de/kontakt#299370" target="_blank" data-tealium-rel="content.button.zu-den-kontaktformularen" class="btn btn--inline">Zu den Kontaktformularen ${externalLinkIcon}</a>`,
    },
    {
      theme: 'dark',
      align: 'left',
      content:
        '<h2 class="text--h4 text--mb">Kontakt zur Brodos</h2><div>Wir helfen bei:</div><ul class="list grid__item--spacing-1"><li class="list__element list__element--dashed">Fragen rund um Geräte-Lieferungen der Brodos AG</li></ul><a href="mailto:telekom-onlineshop-service@brodos.de" data-tealium-rel="content.button.e-mail-an-den-kundenservice-brodos" class="btn btn--inline">E-Mail an den Kundenservice</a>',
    },
  ],
  shops: {
    theme: 'dark',
    align: 'center',
    content:
      '<h2 class="text--h4 text--mb">Telekom Shop finden</h2><p>Wir beraten gerne zu unseren Produkten in mehr als 730 Telekom Shops.</p>',
  },
});
const tabsData = ref([
  {
    name: 'hotline',
    label: 'HOTLINE',
  },
  {
    name: 'e-mail',
    label: 'E-MAIL',
  },
  {
    name: 'shops',
    label: 'SHOPS',
  },
]);

const breadcrumb = ref([
  {
    label: 'Kontakt',
    to: $route.path,
  },
]);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.kontakt {
  .text--spacing-kontakt {
    margin-top: 24px;
    margin-bottom: 48px;
  }
  .text {
    &--highlighted {
      color: var(--color-primary);
    }
  }
}
</style>
